(function (global, factory) {
    if (typeof define === "function" && define.amd) {
      define(["exports", "smart/events.m.js", "smart/mixin.m.js", "smart/syncProps.m.js"], factory);
    } else if (typeof exports !== "undefined") {
      factory(exports, require("smart/events.m.js"), require("smart/mixin.m.js"), require("smart/syncProps.m.js"));
    } else {
      var mod = {
        exports: {}
      };
      factory(mod.exports, global.eventsM, global.mixinM, global.syncPropsM);
      global.tableM = mod.exports;
    }
  })(this, function (_exports, _eventsM, _mixinM, _syncPropsM) {
    "use strict";
  
    Object.defineProperty(_exports, "__esModule", {
      value: true
    });
    _exports["default"] = void 0;
    _syncPropsM = _interopRequireDefault(_syncPropsM);
  
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
  
    function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
  
    function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
  
    function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
  
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
  
    function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
  
    function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
  
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
  
    function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
  
    function isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
  
    function _construct(Parent, args, Class) { if (isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
  
    function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
  
    function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
  
    function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
  
    // We need a Base class for composition 
    var Base =
    /*#__PURE__*/
    function (_HTMLTableElement) {
      _inherits(Base, _HTMLTableElement);
  
      function Base() {
        var _getPrototypeOf2;
  
        _classCallCheck(this, Base);
  
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
  
        return _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Base)).call.apply(_getPrototypeOf2, [this].concat(args)));
      }
  
      return Base;
    }(_wrapNativeSuper(HTMLTableElement));
  
    (0, _mixinM.mix)(Base.prototype, {
      handleEvent: _eventsM.handleEvent,
      on: _eventsM.on,
      off: _eventsM.off,
      fire: _eventsM.fire
    }, _syncPropsM["default"]);
    /**
     * Table component
     * @extends {HTMLTableElement}
     * @example let table = document.createElement('table', {is: 'zs-table'});
     */
  
    var Table =
    /*#__PURE__*/
    function (_Base) {
      _inherits(Table, _Base);
  
      function Table() {
        var _getPrototypeOf3;
  
        var _this;
  
        _classCallCheck(this, Table);
  
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
  
        // Constructor caveat https://github.com/WebReflection/document-register-element/
        var _ = _this = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(Table)).call.apply(_getPrototypeOf3, [this].concat(args)));
  
        _.init();
  
        return _possibleConstructorReturn(_this, _);
      }
      /**
       * Helps to normalize `is` attribute value across browsers.
       * @private 
       */
  
  
      _createClass(Table, [{
        key: "_patchIs",
        value: function _patchIs() {
          if (this.parentNode && this._is) {
            if (this.getAttribute('is') != this._is) {
              this.setAttribute('is', this._is);
            }
          }
        }
        /**
         * Use this method with or instead of the constructor to normalize the flow across browsers. 
         *  Call it in the `constructor`, in the `attributeChangeCallback` and in the `connectedCallback` before any other methods or immediately after `document.createElement`
         */
  
      }, {
        key: "init",
        value: function init() {
          this._patchIs();
  
          if (this._isCreated) {
            return this;
          }
          /** @type {object} columns - Get settings for columns of the table. Enables formatting, labeling and sorting of columns. Supports column groups. Set it using column groups configurations. */
  
  
          this._columns = undefined;
          /** @type {string} selectionMode - Turn on cells selection. Accepts values `cell`, `row`, `column`, `multi`. */
  
          this.syncProp('selectionMode');
          /** @type {string} sortColumn - Set or get a column name the table is sorted by  */
  
          this.syncProp('sortColumn');
          /** @type {string} sortOrder - Set or get a current sort order. Possible values include `asc`, `desc` and empty string. */
  
          this.syncProp('sortOrder'); // Double click is not supported on iOS.
  
          var ua = window.navigator.userAgent;
          var isIpad = (!!ua.match(/iPad/i) || !!ua.match(/iPhone/i)) && !!ua.match(/WebKit/i);
  
          if (isIpad) {
            this._dblTapDelay = 500;
          } else {
            this._dblTapDelay = 0;
          }
  
          this.on(['sort', 'connect', 'click', 'select', 'render', 'focus', 'blur', 'keydown', 'mouseover', 'mouseout', 'dblclick', 'touchstart'], this);
          this._isCreated = true;
          return this;
        }
        /**
         * @type {array} observedAttributes - Observed attributes. Custom Elements API.
         */
  
      }, {
        key: "onclick",
  
        /**
         * Click event handler. 
         * @todo implement double tap as double click
         * @param {MouseEvent} event 
         */
        value: function onclick(event) {
          if (event.target.tagName == 'A' && event.target.getAttribute('sort') != null) {
            // sort anchor clicked
            var a = event.target;
            var columnName = a.parentElement.getAttribute('key');
            var order = a.getAttribute('sort');
            order = order == 'asc' ? 'desc' : 'asc'; // toggle order
  
            if (columnName != this.sortColumn || order != this.sortOrder) {
              this.sortColumn = columnName;
              this.sortOrder = order;
              this.fire('sort', {
                bubbles: true,
                detail: {
                  columnName: this.sortColumn,
                  order: this.sortOrder
                }
              });
            }
          }
  
          if (event.target.tagName != 'TD' && event.target.tagName != 'TH') {
            return;
          }
  
          if (this.selectionMode && event.target != document.activeElement) {
            event.target.focus(); // focus on touch
  
            (0, _eventsM.fire)('focus', {
              bubbles: true,
              cancelable: true
            }, event.target);
          }
  
          if (this.selectionMode) {
            // select
            this.applySelection(event.target);
          }
        }
      }, {
        key: "ontouchstart",
        value: function ontouchstart(event) {
          // mimic dbl click when not supported on iOS devices
          if (event.target._possibleDblTap) {
            var delta = performance.now() - event.target._possibleDblTap;
  
            if (delta > this._dblTapDelay) {
              event.target._possibleDblTap = null;
            } else {
              event.target._possibleDblTap = null;
              event.target.dispatchEvent(new MouseEvent('dblclick', {
                'view': window,
                'bubbles': true,
                'cancelable': true
              }));
            }
          } else if (this._dblTapDelay) {
            event.target._possibleDblTap = performance.now();
          }
        }
        /**
         * Decide how to perform selection based on the mode and targeted table cell. Part of the selection feature.
         * @param {HTMLTableCellElement|HTMLTableHeaderCellElement} cell Target cell
         */
  
      }, {
        key: "applySelection",
        value: function applySelection(cell) {
          if (!cell) {
            return;
          }
  
          if (cell.tagName != 'TD' && cell.tagName != 'TH') {
            return;
          }
  
          var columnName = cell.getAttribute('key');
          var rowIndex = cell.parentElement.getAttribute('key');
          var mode = this._selectionModeObject;
          var isSelected = cell.getAttribute('mark') != null;
  
          if (!mode.multi) {
            this.clearSelection();
          }
  
          if (mode.row) {
            this.select(~~rowIndex, undefined, isSelected);
          } else if (mode.cell) {
            this.select(~~rowIndex, columnName, isSelected);
          } else if (mode.column) {
            this.select(undefined, columnName, isSelected);
          }
        }
        /**
         * Find a cell by column name
         * @param {HTMLTableCellElement} startCell Starting cell
         * @param {string} columnName Name of the column to look for
         * @param {?boolean} backward Look backward
         * @retuns {HTMLTableCellElement} Found cell or undefined
         */
  
      }, {
        key: "findCell",
        value: function findCell(startCell, columnName, backward) {
          var found = null,
              end = false;
          var cell = startCell;
  
          if (!columnName) {
            return;
          }
  
          while (!found && !end) {
            if (backward) {
              cell = this.findPrev(cell);
            } else {
              cell = this.findNext(cell);
            }
  
            if (!cell) {
              return;
            }
  
            if (cell.getAttribute('key') == columnName) {
              return cell;
            }
          }
  
          return found;
        }
        /**
         * Find previous cell
         * @param {HTMLTableCellElement} cell Current cell to start looking from
         * @retuns {HTMLTableCellElement} Found cell or undefined
         */
  
      }, {
        key: "findPrev",
        value: function findPrev(cell) {
          if (cell.previousElementSibling) {
            return cell.previousElementSibling;
          }
  
          ;
  
          if (!cell.parentElement.previousElementSibling) {
            return;
          } // last row
  
  
          return cell.parentElement.previousElementSibling.lastElementChild;
        }
        /**
         * Find next cell
         * @param {HTMLTableCellElement} cell Current cell to start looking from
         * @retuns {HTMLTableCellElement} Found cell or undefined
         */
  
      }, {
        key: "findNext",
        value: function findNext(cell) {
          if (cell.nextElementSibling) {
            return cell.nextElementSibling;
          }
  
          ;
  
          if (!cell.parentElement.nextElementSibling) {
            return;
          } // last row
  
  
          return cell.parentElement.nextElementSibling.firstElementChild;
        }
        /**
         * Keydown event handler to navigate the cells and enter or select a cell using keyboard
         * @param {KeyboardEvent} event 
         */
  
      }, {
        key: "onkeydown",
        value: function onkeydown(event) {
          if (event.target.tagName != 'TD' && event.target.tagName != 'TH') {
            return;
          } // Navigate cells 
  
  
          if (event.target == document.activeElement) {
            var nextCell;
  
            if (event.keyCode == 9 && event.shiftKey || event.keyCode == 37) {
              // Left
              nextCell = this.findPrev(event.target);
              event.preventDefault();
              event.stopPropagation();
            } else if (event.keyCode == 9 || event.keyCode == 39) {
              // Right
              event.preventDefault();
              event.stopPropagation();
              nextCell = this.findNext(event.target);
            } else if (event.keyCode == 38) {
              // Up
              nextCell = this.findCell(event.target, event.target.getAttribute('key'), true);
            } else if (event.keyCode == 40) {
              // Down
              nextCell = this.findCell(event.target, event.target.getAttribute('key'));
            } else if (event.keyCode == 27) {
              // ESC
              event.target.blur();
              (0, _eventsM.fire)('blur', {
                bubbles: true,
                cancelable: true
              }, event.target);
            } else if (event.keyCode == 13) {
              // Enter
              // Double click
              var _event = new MouseEvent('dblclick', {
                'view': window,
                'bubbles': true,
                'cancelable': true
              });
  
              document.activeElement.dispatchEvent(_event);
            } else if (event.keyCode == 32) {
              // Space
              // Click
              event.target.click();
            } // Found next cell
  
  
            if (nextCell) {
              nextCell.focus();
              (0, _eventsM.fire)('focus', {
                bubbles: true,
                cancelable: true
              }, nextCell);
            }
          }
        }
        /**
         * Mouse over event handler. Helps to give focus to cells.
         * @param {MouseEvent} event 
         */
  
      }, {
        key: "onmouseover",
        value: function onmouseover(event) {
          if (event.target.tagName != 'TD' && event.target.tagName != 'TH') {
            return;
          }
  
          if (this.selectionMode && event.target.tabIndex == -1 && event.target != document.activeElement) {
            event.target.focus();
            (0, _eventsM.fire)('focus', {
              bubbles: true,
              cancelable: true
            }, event.target);
          }
        }
        /**
         * Mouse out event handler. Helps to remove focus from cells.
         * @param {MouseEvent} event 
         */
  
      }, {
        key: "onmouseout",
        value: function onmouseout(event) {
          if (document.activeElement && (document.activeElement.tagName == 'TD' || document.activeElement.tagName == 'TH') && this.contains(document.activeElement)) {
            event.target.blur();
            (0, _eventsM.fire)('blur', {
              bubbles: true,
              cancelable: true
            }, event.target); // Manual blur doesn't fire on cells
          }
        }
        /**
         * Callback triggered when synchronized property or attribute was changed.
         * @param {string} name Property name in lower camel case e.g. `myProperty`
         * @param {number|boolean|string} oldValue Old value of the property. 
         * @param {number|boolean|string} newValue New value of the property.
         */
  
      }, {
        key: "propertyChangedCallback",
        value: function propertyChangedCallback(name, oldValue, newValue) {
          var _this2 = this;
  
          var sortColumn, sortOrder;
  
          switch (name) {
            case 'sortColumn':
              sortColumn = newValue;
  
            case 'sortOrder':
              if (name == 'sortOrder') {
                sortOrder = newValue;
              } // Don't have sortColumn defined yet
  
  
              if (!(this.sortColumn || sortColumn)) {
                break;
              } // Update sort indicators
  
  
              this.querySelectorAll('a[sort]').forEach(function (el) {
                var columnName = el.parentElement.getAttribute('key');
  
                if (columnName == (sortColumn || _this2.sortColumn)) {
                  el.setAttribute('sort', _this2.sortOrder || sortOrder || '');
                } else {
                  el.setAttribute('sort', '');
                }
              });
              break;
  
            case 'selectionMode':
              console.log('selectionMode', newValue);
              this._selectionModeObject = {
                row: newValue && newValue.indexOf('row') != -1,
                column: newValue && newValue.indexOf('column') != -1,
                cell: newValue && newValue.indexOf('cell') != -1,
                multi: newValue && newValue.indexOf('multi') != -1
              };
  
              if (newValue == '' || newValue == null) {
                this.root.querySelectorAll('[tabindex]').forEach(function (el) {
                  return el.tabIndex = null;
                });
              } else {
                this.tbody.querySelectorAll('td[key]').forEach(function (el) {
                  return el.tabIndex = -1;
                });
              }
  
          }
        }
        /**
         * Callback triggered when an observed attributed was changed. Custom Elements API.	 
         * @param {string} name Attribute name in dash lower case e.g. `my-attribute`
         * @param {string} oldValue Old value of the attribute
         * @param {string} newValue New value of the attribute
         */
  
      }, {
        key: "attributeChangedCallback",
        value: function attributeChangedCallback(name, oldValue, newValue) {
          this.init();
  
          switch (name) {
            case 'sort-column':
            case 'sort-order':
            case 'selection-mode':
              this.syncAttr(name, newValue);
              break;
  
            case 'onconnect':
            case 'onrender':
            case 'onselect':
            case 'onsort':
              var _onabort = this.onabort;
  
              var _onabortAttr = this.getAttribute('onabort');
  
              this.setAttribute('onabort', newValue);
              this[name] = this.onabort;
              this.onabort = _onabort;
  
              if (_onabortAttr == null) {
                this.removeAttribute('onabort');
              } else {
                this.setAttribute('onabort', _onabortAttr);
              }
  
              break;
          }
        }
        /**
         * Callback triggered when this element is attached to the DOM. Can be called multiple times. Custom Elements API.
         */
  
      }, {
        key: "connectedCallback",
        value: function connectedCallback() {
          this.init();
          this.fire('connect');
        }
        /**
         * Root element of the table
         * @type {HTMLTableElement}
         */
  
      }, {
        key: "createRow",
  
        /**
         * Creates  a table row and adds cells to it using data and columns configuration.
         * @param {number} rowIndex Index of the row.
         * @param {(Array|object)} rowData Data required to render the row.
         * @param {object} columns Hash-table of columns properties
         * @returns {HTMLElement} Table row.
         */
        value: function createRow(rowIndex, rowData, columns) {
          var tr = document.createElement('tr');
          tr.setAttribute('key', rowIndex);
  
          if (!columns || _typeof(columns) != 'object') {
            throw 'Invalid columns';
          }
  
          for (name in columns) {
            var column = columns[name];
            var data = rowData[name];
            tr.appendChild(this.createCell(rowIndex, name, data, column));
          }
  
          ;
          return tr;
        }
        /**
         * Creates and renders the table header row.
         * @returns {HTMLElement} Returns HTML tr element.
         */
  
      }, {
        key: "createHeadRow",
        value: function createHeadRow(columns) {
          if (!columns || _typeof(columns) != 'object') {
            return tr;
          }
  
          var tr = document.createElement('tr');
  
          for (var key in columns) {
            tr.appendChild(this.createHeadCell(columns[key]));
          }
  
          return tr;
        }
        /**
         * Creates and renders the header cell.
         * @param {number} rowIndex Index of the row.
         * @param {number} colIndex Index of the column.
         * @param {any} data Cell data based on the table data array.
         * @returns {HTMLElement} Returns HTML td element.
         */
  
      }, {
        key: "createHeadCell",
        value: function createHeadCell(column) {
          if (!column || _typeof(column) != 'object') {
            throw 'Invalid column';
          }
  
          var th = document.createElement('td');
          th.setAttribute('key', column.name);
  
          if (column.colspan) {
            th.setAttribute('colspan', column.colspan);
          }
  
          if (column.scope) {
            th.setAttribute('scope', column.scope);
          }
  
          var label = column.label || column.name;
  
          if (column.sortOrder !== undefined) {
            label = "<a href=\"javascript:;\" sort=\"".concat(column.sortOrder || '', "\">").concat(label, "</a>");
          }
  
          th.innerHTML = label;
          return th;
        }
        /**
         * Create a table body cell
         * @param {number} rowIndex Index of the row.
         * @param {number} colIndex Index of the column.
         * @param {any} data Cell data based on the table data array.
         * @column {?object} column Optional column definition object
         * @returns {HTMLTableCellElement} Table cell element.
         */
  
      }, {
        key: "createCell",
        value: function createCell(rowIndex, colIndex, data, column) {
          var td = document.createElement('td');
          this.updateCell(td, data, column);
          return td;
        }
        /**
         * Update contents of a table row
         * @param {HTMLTableRowElement} tr Row to update
         * @param {object} rowData Record with data
         * @param {object} columns Hash-table with columns configurations
         */
  
      }, {
        key: "updateRow",
        value: function updateRow(tr, rowData, columns) {
          if (!tr || tr instanceof HTMLTableRowElement == false) {
            return;
          }
  
          if (!rowData || _typeof(rowData) != 'object') {
            return;
          }
  
          if (!columns || _typeof(columns) != 'object') {
            throw 'Invalid columns';
          }
  
          for (var _name in rowData) {
            var column = columns[_name];
            var data = rowData[_name];
  
            if (column) {
              var td = tr.querySelector('[key="' + _name + '"]');
  
              if (td) {
                this.updateCell(td, data, column);
              }
  
              ;
            }
          }
  
          ;
        }
        /**
         * Update table or its part with new contents
         * @param {array} newData Record set with data
         * @param {?number} rowIndex Optional starting row index.  
         */
  
      }, {
        key: "update",
        value: function update(newData, rowIndex) {
          if (!Array.isArray(newData)) {
            return;
          }
  
          if (!this.tbody || !this.tbody.rows.length) {
            return;
          }
  
          for (var i = 0; i < newData.length; i++) {
            var tr = this.tbody.rows[(rowIndex || 0) + i];
            var rowData = newData[i];
  
            if (tr && rowData) {
              this.updateRow(tr, rowData, this.columns);
            }
          }
        }
        /**
         * Update a cell content
         * @param {HTMLTableCellElement} td Table cell to update
         * @param {any} data Contents. 
         * @param {object} column Column configuration object
         */
  
      }, {
        key: "updateCell",
        value: function updateCell(td, data, column) {
          if (column && typeof column.format == 'function') {
            data = column.format(data);
          }
  
          if (column && column.scope) {
            td.setAttribute('scope', column.scope);
          }
  
          if (column && column.name) {
            td.setAttribute('key', column.name);
          }
  
          if (this.selectionMode != '' && this.selectionMode != null) {
            td.tabIndex = -1;
          }
  
          td.innerHTML = data == null ? '' : data;
        }
        /**
         * Clear table
         */
  
      }, {
        key: "clear",
        value: function clear() {
          this.columns = null;
          this.root.innerHTML = '';
        }
        /**
         * Table head section
         * @type {HTMLTableSectionElement}
         */
  
      }, {
        key: "createFoot",
  
        /**
         * Create table foot section
         */
        value: function createFoot() {
          return this.createTFoot();
        }
        /**
         * Create a table column `<col>` element to support grouping and style cells of the column.
         * @param {object} columnDefinition Column definition object
         */
  
      }, {
        key: "createCol",
        value: function createCol(columnDefinition) {
          var el = document.createElement('col');
  
          for (var key in columnDefinition) {
            el.setAttribute(_syncPropsM["default"].propToAttrName(key), columnDefinition[key]);
          }
  
          return el;
        }
        /**
         * Columns configuration. Creates a table head and column groups when changed. 
         * @property
         * @name columns
         * @type {object} Hash-table with configurations by column name
         */
  
      }, {
        key: "generateColumns",
  
        /**
         * Create a default columns definition from the data when not provided. Data like this `[{test:1}]` can be reflected as `[{cols: [{name: 'test'}]}]`
         * @param {array} data Record set with data
         * @returns {array} Columns definition
         */
        value: function generateColumns(data) {
          if (!data[0]) {
            return;
          }
  
          var group = {
            cols: []
          };
  
          for (var key in data[0]) {
            group.cols.push({
              name: key
            });
          }
  
          return [group];
        }
        /**
         * Render a table based on provided data considering columns configuration. 
         * @param {array} data Recordset with data `[{id:1, last: 'Smith'}, {id:2, last: 'Lincoln'}]`
         * @param {array} columns Columns definition `[{cols: [{name: 'last'}]}]` 
         */
  
      }, {
        key: "render",
        value: function render(data, columnConfig) {
          this.clear();
          this.columns = columnConfig || this.generateColumns(data);
          this.renderBody(data, this.columns);
          this.fire('render', {
            bubbles: true
          });
        }
        /**
         * Render a table contents from data and columns definitions
         * @param {array} data Recordset with data
         * @param {object} columns Hash-table with columns configuration by name
         */
  
      }, {
        key: "renderBody",
        value: function renderBody(data, columns) {
          for (var i = 0; i < data.length; i++) {
            var tr = this.createRow(i, data[i], columns);
  
            if (tr) {
              this.tbody.appendChild(tr);
            }
          }
        }
        /**
         * Selected cells. Normally would return cells with `mark` attribute.
         * @type {HTMLCollection}
         */
  
      }, {
        key: "clearSelection",
  
        /**
         * Remove selection
         */
        value: function clearSelection() {
          this.selectedCells.forEach(function (el) {
            el.removeAttribute('mark');
          });
        }
        /**
         * Select provided cells
         * @param {HTMLCollection} cells Collection of cells
         * @param {?boolean} unselect Optionally unselect if provided
         * @fires select
         */
  
      }, {
        key: "selectCells",
        value: function selectCells(cells, unselect) {
          if (!cells) {
            return;
          }
  
          if (cells.length == null) {
            cells = [cells];
          }
  
          cells.forEach(function (el) {
            if (unselect) {
              el.removeAttribute('mark');
            } else {
              el.setAttribute('mark', '');
            }
          });
          this.fire('select');
        }
        /**
         * Select a cell or cells by row index or column name. Selects a row when only `rowIndex` is specified. Selects a column when only `columnName` is specified. Or selects a cell if both are specified.
         * @param {?number} rowIndex Optional index of a row to select
         * @param {?string} columnName Optional name of a column
         * @param {?boolean} unselect Optional flag to unselect
         */
  
      }, {
        key: "select",
        value: function select(rowIndex, columnName, unselect) {
          if (rowIndex != null && columnName == null) {
            // row
            var tr = this.tbody.rows[rowIndex];
  
            if (tr) {
              this.selectCells(tr.cells, unselect);
            }
          } else if (rowIndex == null && columnName != null) {
            // column
            var cells = this.root.querySelectorAll('tbody td[key="' + columnName + '"]');
            this.selectCells(cells, unselect);
          } else {
            // cell
            var _tr = this.tbody.rows[rowIndex];
  
            if (_tr) {
              var el = _tr.querySelector('tbody td[key="' + columnName + '"]');
  
              this.selectCells(el, unselect);
            }
          }
        }
        /**
         * Register a custom element.
         * @param {?string} is Name of the new custom element `<my-element>` or `<div is="my-element">`
         * @param {?string} tagName Name of the tag use only when customizing built-ins e.g. `<div is="my-element">`
         */
  
      }, {
        key: "onfocus",
  
        /**
         * Focus event handler
         * @param {Event} event 
         */
        value: function onfocus(event) {}
        /**
         * Select event handler
         * @param {Event} event 
         */
  
      }, {
        key: "onselect",
        value: function onselect(event) {}
        /**
         * Connect event handler
         * @param {CustomEvent} event 
         */
  
      }, {
        key: "onconnect",
        value: function onconnect(event) {}
        /**
         * Render event handler
         * @param {CustomEvent} event 
         */
  
      }, {
        key: "onrender",
        value: function onrender(event) {}
        /**
         * Double click and double tap handler
         * @param {MouseEvent} event 
         */
  
      }, {
        key: "ondblclick",
        value: function ondblclick(event) {}
        /**
         * Blur event handler
         * @param {Event} event 
         */
  
      }, {
        key: "onblur",
        value: function onblur(event) {}
      }, {
        key: "root",
        get: function get() {
          return this;
        }
      }, {
        key: "thead",
        get: function get() {
          return this.createTHead();
        }
        /**
         * Table body section
         * @type {HTMLTableSectionElement}
         */
  
      }, {
        key: "tbody",
        get: function get() {
          if (this.tBodies[0]) {
            return this.tBodies[0];
          }
  
          return this.createTBody();
        }
        /**
         * Table foot section
         * @type {HTMLTableSectionElement}
         */
  
      }, {
        key: "tfoot",
        get: function get() {
          if (this.tfoot) {
            return this.tfoot;
          } else {
            return this.createFoot();
          }
        }
      }, {
        key: "columns",
        get: function get() {
          return this._columns;
        },
        set: function set(columns) {
          // Wrap in a group
          var groups = columns; // Remove <colgroups> or <cols>
  
          this._columns = {};
  
          while (this.querySelector('colgroup,col,thead')) {
            var el = this.querySelector('colgroup,col,thead');
            el.parentElement.removeChild(el);
          }
  
          if (!Array.isArray(groups)) {
            return;
          }
  
          var table = this;
          groups.forEach(function (group) {
            var groupEl = document.createElement('colgroup');
  
            for (var key in group) {
              if (key == 'cols') {
                continue;
              }
  
              groupEl.setAttribute(key, group[key]);
            }
  
            if (Array.isArray(group.cols)) {
              group.cols.forEach(function (col) {
                table._columns[col.name] = col;
                groupEl.appendChild(table.createCol(col));
              });
            }
  
            table.appendChild(groupEl);
          });
          this.thead.appendChild(this.createHeadRow(this._columns));
        }
      }, {
        key: "selectedCells",
        get: function get() {
          return this.root.querySelectorAll('[mark]');
        }
      }], [{
        key: "define",
        value: function define(is, tagName) {
          var Cls = this;
          is = is || 'zs-table';
          tagName = tagName || 'table';
  
          if (tagName) {
            Cls.prototype._is = is; // need to patch is
          } else {
            delete Cls.prototype._is; // don't need to patch is
          }
  
          return customElements.define(is, Cls, tagName ? {
            "extends": tagName
          } : undefined);
        }
      }, {
        key: "observedAttributes",
        get: function get() {
          return ['onconnect', 'selection-mode', 'onrender', 'onselect', 'onsort', 'sort-column', 'sort-order'];
        }
      }]);
  
      return Table;
    }(Base); // ForEach polyfill on HTMLCollection
  
  
    _exports["default"] = Table;
  
    if (HTMLCollection && !HTMLCollection.prototype.forEach) {
      HTMLCollection.prototype.forEach = function (fn, scope) {
        for (var i = 0, len = this.length; i < len; ++i) {
          fn.call(scope, this[i], i, this);
        }
      };
    }
  });
  //# sourceMappingURL=table.js.map